import styles from './AppoinmentStyle.module.css';

export default function PrivacyPolicy() {
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.container}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '48px 24px' }}>
        <h1 style={{ fontSize: '32px', fontWeight: '700', color: '#071028', marginBottom: '8px' }}>
          Privacy Policy
        </h1>
        <p style={{ color: '#888', fontSize: '14px', marginBottom: '40px' }}>
          Last updated: {currentYear}
        </p>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>1. Introduction</h2>
          <p style={body}>
            We are committed to protecting your personal information and your right to privacy. This Privacy Policy describes how we collect, use, and share information when you use our appointment booking services.
          </p>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>2. Information We Collect</h2>
          <p style={body}>We collect the following information when you book an appointment:</p>
          <ul style={list}>
            <li>Full name</li>
            <li>Phone number and email address</li>
            <li>Appointment date, time, and reason for visit</li>
            <li>Doctor or specialist preference</li>
          </ul>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>3. How We Use Your Information</h2>
          <ul style={list}>
            <li>To schedule and confirm your appointment</li>
            <li>To send appointment reminders and follow-up communications</li>
            <li>To improve our services and patient experience</li>
            <li>To comply with applicable healthcare regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>4. Data Sharing</h2>
          <p style={body}>
            We do not sell your personal information. Your data is only shared with the clinic or healthcare provider for whom you are booking the appointment. We do not share your information with third parties for marketing purposes.
          </p>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>5. Data Security</h2>
          <p style={body}>
            We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction.
          </p>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>6. Your Rights</h2>
          <p style={body}>You have the right to:</p>
          <ul style={list}>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>7. Cookies</h2>
          <p style={body}>
            This site may use cookies solely for functional purposes (e.g., maintaining your session). No tracking or advertising cookies are used.
          </p>
        </section>

        <section style={{ marginBottom: '36px' }}>
          <h2 style={sectionTitle}>8. Contact Us</h2>
          <p style={body}>
            If you have any questions about this Privacy Policy or how we handle your data, please contact the clinic directly through the appointment booking page.
          </p>
        </section>

        <p style={{ color: '#aaa', fontSize: '13px', borderTop: '1px solid #eee', paddingTop: '24px' }}>
          &copy; {currentYear} All rights reserved.
        </p>
      </div>
    </div>
  );
}

const sectionTitle = {
  fontSize: '18px',
  fontWeight: '700',
  color: '#1a1a2e',
  marginBottom: '12px',
};

const body = {
  fontSize: '15px',
  color: '#444',
  lineHeight: '1.8',
  marginBottom: '10px',
};

const list = {
  paddingLeft: '20px',
  fontSize: '15px',
  color: '#444',
  lineHeight: '2',
};
